interface JobInfo {
  hours?: string;
  contractType?: string;
  startDate?: string;
  workingTime?: string;
}

export const extractJobInfo = (description: string): JobInfo => {
  // Clean up text and remove bullet points
  const text = description
    .replace(/<[^>]*>/g, '')
    .replace(/\[CDATA\[|\]\]/g, '')
    .replace(/[•▪▫▯▸▹◦‣⁃]/g, '') // Remove various bullet point characters
    .replace(/^\s*[\-\*]\s*/gm, ''); // Remove dash/asterisk bullet points
  
  const info: JobInfo = {};
  
  // Extract working hours - improved regex to catch more variations
  const hoursMatch = text.match(/(\d+)\s*(?:Stunden?|Std\.?)\s*(?:pro\s*Woche|\/\s*Woche)/i);
  if (hoursMatch) {
    info.hours = `${hoursMatch[1]} Stunden pro Woche`;
  }
  
  // Extract contract type - remove bullet points from result
  if (text.match(/unbefristet/i)) {
    info.contractType = "unbefristet";
  } else if (text.match(/befristet/i)) {
    info.contractType = "befristet";
  }
  
  // Extract start date - improved regex and clean result
  const startMatch = text.match(/(?:Frühester\s*)?Beginn\s*(?:ab\s*)?(.*?)(?:\n|$|•|,|\.|!)/i);
  if (startMatch) {
    let startDate = startMatch[1].trim();
    // Clean up common prefixes and suffixes
    startDate = startDate.replace(/^(ab\s*|zum\s*)/i, '');
    info.startDate = `Frühester Beginn ${startDate}`;
  } else if (text.match(/ab\s*sofort/i)) {
    info.startDate = "Frühester Beginn ab sofort";
  }
  
  // Extract working time type
  if (text.match(/vollzeit/i)) {
    info.workingTime = "Vollzeit";
  } else if (text.match(/teilzeit/i)) {
    info.workingTime = "Teilzeit";
  }
  
  return info;
};